<template>
    <div v-show="enabled">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        'title': {
            type: String,
            required: true
        },
        'sottotitolo': {
            type: String,
            required: false
        },
        'background-src': {
            type: String,
            required: false
        }
    },
    name: 'page',
    data() {
        return {
            enabled: false,
        }
    }, 
    methods: {
        enable() { 
            this.enabled = true; 
            for(let child of  this.$children) {  
                console.log(child);
                
                child.onNavigateTo(); 
            }
        },
        disable() {
            this.enabled = false;
        }
    }
}
</script>